export default {"src":"/_next/static/media/taskeen-logo.c806e188.svg","height":40,"width":108,"blurWidth":0,"blurHeight":0};